import React from 'react';
import Header from '../components/Header';
import FooterMinimal from '../components/FooterMinimal';
import { useLanguage, useLocalizedNavigate } from '../contexts/LanguageContext';
import { openCookieSettings } from '../analytics/consent';

// Informations issues de l'extrait Kbis (RCS Nanterre, 24/03/2026).
const content = {
  fr: {
    title: 'Mentions légales',
    sections: [
      {
        title: 'Éditeur du site',
        lines: [
          'ALTES PROTECTION, société par actions simplifiée (SAS) au capital de 10 000 €',
          'Siège social : 30 rue Pasteur, 92150 Suresnes, France',
          'RCS Nanterre 102 692 134 — EUID FR9201.102692134',
          'Établissement à Monaco : Le Patio Palace, 41 avenue Hector Otto, 98000 Monaco',
          'Téléphone : +33 1 80 88 95 87 — Email : info@altes-protection.com',
          'Présidente : LORANS HOLDING (SAS, RCS Nanterre 983 940 776)'
        ]
      },
      {
        title: 'Directeur de la publication',
        lines: ['LORANS HOLDING, Présidente d’ALTES PROTECTION, représentée par son représentant légal.']
      },
      {
        title: 'Activité réglementée',
        lines: [
          'Activité de protection physique des personnes, soumise à autorisation du Conseil national des activités privées de sécurité (CNAPS).',
          "Autorisation d'exercice n° 2026-0070492-AUT-1088774.",
          "L'autorisation d'exercice délivrée par le CNAPS ne confère aucune prérogative de puissance publique à l'entreprise ou aux personnes qui en bénéficient (article L. 612-14 du code de la sécurité intérieure)."
        ]
      },
      {
        title: 'Hébergement',
        lines: [
          'OVH SAS, 2 rue Kellermann, 59100 Roubaix, France — www.ovhcloud.com'
        ]
      },
      {
        title: 'Propriété intellectuelle',
        lines: [
          "L'ensemble des contenus de ce site (textes, logos, images, vidéos) est la propriété d'ALTES PROTECTION ou fait l'objet d'une autorisation d'utilisation. Toute reproduction sans autorisation écrite préalable est interdite.",
          "Les noms d'établissements, d'événements et de marques cités sur ce site appartiennent à leurs propriétaires respectifs. Leur mention ne signifie aucune affiliation ni aucun partenariat avec ALTES PROTECTION."
        ]
      },
      {
        title: 'Données personnelles et cookies',
        lines: [
          'Les informations transmises via le formulaire de contact sont utilisées uniquement pour répondre à votre demande. Pour en savoir plus, consultez notre politique de confidentialité.',
          "Les cookies de mesure d'audience et de publicité ne sont déposés qu'avec votre accord. Vous pouvez modifier votre choix à tout moment."
        ]
      }
    ],
    privacyLink: 'Politique de confidentialité',
    cookiesLink: 'Gérer mes cookies'
  },
  en: {
    title: 'Legal notice',
    sections: [
      {
        title: 'Website publisher',
        lines: [
          'ALTES PROTECTION, simplified joint-stock company (SAS) with share capital of €10,000',
          'Registered office: 30 rue Pasteur, 92150 Suresnes, France',
          'Nanterre Trade and Companies Register (RCS) 102 692 134 — EUID FR9201.102692134',
          'Monaco office: Le Patio Palace, 41 avenue Hector Otto, 98000 Monaco',
          'Phone: +33 1 80 88 95 87 — Email: info@altes-protection.com',
          'President: LORANS HOLDING (SAS, RCS Nanterre 983 940 776)'
        ]
      },
      {
        title: 'Publication director',
        lines: ['LORANS HOLDING, President of ALTES PROTECTION, represented by its legal representative.']
      },
      {
        title: 'Regulated activity',
        lines: [
          'Close protection activity, subject to authorisation by the French National Council for Private Security Activities (CNAPS).',
          'Operating authorisation n° 2026-0070492-AUT-1088774.',
          'The operating authorisation issued by the CNAPS confers no public authority prerogative on the company or the persons who benefit from it (article L. 612-14 of the French Internal Security Code).'
        ]
      },
      {
        title: 'Hosting',
        lines: ['OVH SAS, 2 rue Kellermann, 59100 Roubaix, France — www.ovhcloud.com']
      },
      {
        title: 'Intellectual property',
        lines: [
          'All content on this website (text, logos, images, videos) belongs to ALTES PROTECTION or is used with permission. Any reproduction without prior written consent is prohibited.',
          'Names of hotels, events and brands mentioned on this website belong to their respective owners. Their mention does not imply any affiliation or partnership with ALTES PROTECTION.'
        ]
      },
      {
        title: 'Personal data and cookies',
        lines: [
          'Information sent through the contact form is used only to answer your request. To find out more, see our privacy policy.',
          'Audience measurement and advertising cookies are only set with your consent. You can change your choice at any time.'
        ]
      }
    ],
    privacyLink: 'Privacy policy',
    cookiesLink: 'Manage my cookies'
  }
};

const MentionsLegalesPage = () => {
  const navigate = useLocalizedNavigate();
  const { language, localizePath } = useLanguage();
  const t = content[language];

  return (
    <div className="App">
      <Header />
      <main style={{ background: '#000', minHeight: '100vh', paddingTop: '140px', paddingBottom: '6rem', color: '#fff' }}>
        <div className="container-custom" style={{ maxWidth: '900px' }}>
          <button
            onClick={() => navigate('/')}
            style={{
              background: 'transparent',
              border: '1px solid #262626',
              color: '#a3a3a3',
              padding: '0.75rem 1.5rem',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '0.9rem',
              marginBottom: '3rem'
            }}
          >
            ← {language === 'fr' ? 'Retour' : 'Back'}
          </button>

          <h1 style={{ fontSize: '3.5rem', fontWeight: 300, marginBottom: '4rem', letterSpacing: '-0.02em' }}>
            {t.title}
          </h1>

          {t.sections.map((section) => (
            <section key={section.title} style={{ padding: 0, marginBottom: '3rem' }}>
              <h2 style={{ fontSize: '1.3rem', fontWeight: 400, marginBottom: '1rem' }}>{section.title}</h2>
              {section.lines.map((line) => (
                <p key={line} style={{ fontSize: '1rem', color: '#a3a3a3', lineHeight: 1.8, fontWeight: 300 }}>{line}</p>
              ))}
            </section>
          ))}

          <div style={{ display: 'flex', gap: '1.5rem', flexWrap: 'wrap' }}>
            <a
              href={localizePath('/confidentialite')}
              onClick={(e) => { e.preventDefault(); navigate('/confidentialite'); }}
              style={{ color: '#fff' }}
            >
              {t.privacyLink}
            </a>
            <button
              onClick={openCookieSettings}
              style={{ background: 'none', border: 'none', color: '#fff', textDecoration: 'underline', cursor: 'pointer', fontSize: '1rem', padding: 0 }}
            >
              {t.cookiesLink}
            </button>
          </div>
        </div>
      </main>
      <FooterMinimal />
    </div>
  );
};

export default MentionsLegalesPage;
